import React, { useState, useEffect } from 'react';
import { Link, useCurrentRoute } from 'react-navi';
import {
  ExternalLink,
  SideNav,
  SideNavItem,
  SideNavMenu,
  SideNavToggler,
} from '@zen-common/components-base';
import PATHS from '../../paths';
import DOCS from '../../utils/documentationLinks';

export default function MainSideNav() {
  const [isOpen, setIsOpen] = useState(false);
  const {
    url: { href },
  } = useCurrentRoute();

  // close on route change
  useEffect(() => {
    setIsOpen(false);
  }, [href]);

  return (
    <>
      <SideNavToggler isOpen={isOpen} onClick={() => setIsOpen((o) => !o)} />
      <SideNav width="100%" marginTop="56px" isOpen={isOpen} onClick={() => setIsOpen(false)}>
        <SideNavItem>
          <Link href={PATHS.ISSUE} exact={false} activeClassName="active">
            Issue
          </Link>
        </SideNavItem>
        <SideNavItem>
          <Link href={PATHS.REDEEM} exact={false} activeClassName="active">
            Redeem
          </Link>
        </SideNavItem>
        <SideNavItem>
          <Link href={PATHS.CANCEL} exact={false} activeClassName="active">
            Cancel
          </Link>
        </SideNavItem>
        <SideNavMenu title="Verify" active>
          <SideNavItem>
            <Link href={PATHS.VERIFY_ASSET} exact={false} activeClassName="active">
              By Asset
            </Link>
          </SideNavItem>
          <SideNavItem>
            <Link href={PATHS.VERIFY_EVENT} exact={false} activeClassName="active">
              By Event
            </Link>
          </SideNavItem>
        </SideNavMenu>
        <SideNavItem>
          <ExternalLink href={DOCS.DEFAULT} exact={false} className="menu-item">
            DOCS
          </ExternalLink>
        </SideNavItem>
        <SideNavMenu
          title="Settings"
          active={[PATHS.SETTINGS_CONNECTIVITY, PATHS.SETTINGS_CONTRACTS].includes(href)}
        >
          <SideNavItem>
            <Link href={PATHS.SETTINGS_CONNECTIVITY} activeClassName="active">
              Connectivity
            </Link>
          </SideNavItem>
          <SideNavItem>
            <Link href={PATHS.SETTINGS_CONTRACTS} activeClassName="active">
              Versions
            </Link>
          </SideNavItem>
        </SideNavMenu>
      </SideNav>
    </>
  );
}
